import { render, staticRenderFns } from "./Users.create.vue?vue&type=template&id=88fc5f5e&"
import script from "./Users.create.vue?vue&type=script&lang=js&"
export * from "./Users.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports